import styles from './TableHead.module.scss';
import { OptionTableColumnsProps } from './types';

interface TableHeadProps {
  columns: OptionTableColumnsProps[];
  className?: string;
}

const TableHead = ({ className, columns }: TableHeadProps) => {
  const combinedClassName = [styles.tableHeadContainer, className].filter(Boolean).join(' ');
  return (
    <div className={combinedClassName}>
      {columns.map(column => (
        <div key={column.key}>{column.title}</div>
      ))}
    </div>
  );
};

export default TableHead;
